import { Serializer } from "src/app/core/common/http/serializer";
import { AreaUbiquityResource } from "./area-ubiquity.resource";
import { AreaUbiquityModel } from "../model/area-ubiquity.model";

export class AreaUbiquitySerializer implements Serializer {
  fromJson(json: any): AreaUbiquityResource {
    const resource = new AreaUbiquityResource();
    resource.cm_riferimento = json.cm_riferimento;
    resource.notes = json.notes;
    return resource;
  }

  toJson(model: AreaUbiquityModel): any {
    const resource = new AreaUbiquityResource();
    resource.cm_riferimento = model.cm_riferimento;
    resource.notes = model.notes;
    return resource;
  }
}